export const config = {
    margin: 15,
    borderMargin: 10,
    contentMargin: 20,
    fontSize: 9,
    bordergap: 5,
    headerTableHeight: 55,
    headerTitleHeight: 20, // Space for title text
    headerSecondTableHeight: 15,
    headerSpacing: 10,
    footerTableHeight: 95,  // Footer total height
    footerMargin: 2,
    footerCellPadding: 3,
    footerImgHeight: 0,
};

export const tableConfiguration = {
  margins: { top: 0, right: 25, bottom: 0, left: 25 },
};

export const tableConfigurationheaderandfooter = {
  margins: { top: 0, right: 15, bottom: 0, left: 15 },
};

export const waterMarkImgConfig = {
  logoWidth: 250,
  logoHeight: 200,
};
